import { render, staticRenderFns } from "./sn.vue?vue&type=template&id=b94263e6&scoped=true"
import script from "./sn.vue?vue&type=script&lang=js"
export * from "./sn.vue?vue&type=script&lang=js"
import style0 from "./sn.vue?vue&type=style&index=0&id=b94263e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94263e6",
  null
  
)

export default component.exports